// src/store/thunks/userThunks.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../remote/apiService';
import { setUser, setLoading } from '../slices/userSlice';
import {EmailVerifyCodeRequest, LoginRequest, RegisterRequest} from '../../remote/types/requests';
import { Profile } from '../../remote/types/responses';
export const loginUser = createAsyncThunk(
    'user/login',
    async (credentials: LoginRequest, { dispatch }) => {
        dispatch(setLoading(true));
        try {
            const response = await apiService.login({
                email: credentials.email,
                password: credentials.password
            });
            if (response.code === 200) {
                dispatch(setUser({ ...response.data, isLogin: true }));
            }
            return response;
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const registerUser = createAsyncThunk(
    'user/register',
    async (data: RegisterRequest, { dispatch }) => {
        dispatch(setLoading(true));
        try {
            const response = await apiService.register({
                email: data.email,
                password: data.password,
                verificationCode: data.verificationCode
            });
            return response;
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const fetchUserProfile = createAsyncThunk(
    'user/fetchProfile',
    async (userId: string, { dispatch }) => {
        dispatch(setLoading(true));
        try {
            const response = await apiService.getUserProfile(userId);
            if (response.code === 200) {
                dispatch(setUser(response.data));
            }
            return response;
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const updateUserProfile = createAsyncThunk(
    'user/updateProfile',
    async ({ userId, userData }: { userId: string; userData: Partial<Profile> }, { dispatch }) => {
        dispatch(setLoading(true));
        try {
            const response = await apiService.updateUserProfile(userId, userData);
            if (response.code === 200) {
                dispatch(fetchUserProfile(userId));
            }
            return response;
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const sendEmailCode = createAsyncThunk(
    'user/sendEmailCode',
    async (action: EmailVerifyCodeRequest, { dispatch }) => {
        dispatch(setLoading(true));
        try {
            const response = await apiService.sendEmailCode({
                email: action.email,
                action: action.action
            });
            return response;
        } finally {
            dispatch(setLoading(false));
        }
    }
);
